import Promise from 'promise'
import axios from 'axios'

const LMS_USER_API_URL = '/api'
axios.defaults.withCredentials = true

export default {
  get () {
    return new Promise((resolve, reject) => {
      axios.get(LMS_USER_API_URL + '/nodes')
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  patch (netdevId, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: LMS_USER_API_URL + '/nodes/' + netdevId.toString(),
        method: 'patch',
        data: data
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  post (data) {
    return new Promise((resolve, reject) => {
      axios({
        url: LMS_USER_API_URL + '/nodes',
        method: 'post',
        data: data
      })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/backend-resources/netdevice-resource.js